/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsMarketBarcodeReqVo } from './GoodsMarketBarcodeReqVo';
import {
    GoodsMarketBarcodeReqVoFromJSON,
    GoodsMarketBarcodeReqVoFromJSONTyped,
    GoodsMarketBarcodeReqVoToJSON,
    GoodsMarketBarcodeReqVoToJSONTyped,
} from './GoodsMarketBarcodeReqVo';

/**
 * 
 * @export
 * @interface AddOrUpdateGoodsVo
 */
export interface AddOrUpdateGoodsVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    id?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    userId?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    code?: string;
    /**
     * 商品来源 1 普通url下单， 2 sku下单， 3 库存下单， 4 复制购物车
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    sourceType?: number;
    /**
     * 商品SKU ID
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    skuId?: number;
    /**
     * 是否合包商品 0 否 1 是
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    combined?: number;
    /**
     * 商品SKU构成的产品的id  只有sku下的基础商品这个字段有值
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    skuProductId?: number;
    /**
     * 商品排序
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    sort?: number;
    /**
     * 购买商品的所在平台的url
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    purchasePlatformUrl?: string;
    /**
     * 品牌
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    brand?: string;
    /**
     * CO商品名称（英文）
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    coGoodsNameEn?: string;
    /**
     * CO海关编码
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    coHsCode?: string;
    /**
     * 产地证类型  三种取值  FTA APAC RCEP
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    hsCodeType?: string;
    /**
     * 商品名称（英文）
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    nameEn?: string;
    /**
     * 商品数量
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    initQuantity?: number;
    /**
     * 当前可用商品数量
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    availableQuantity?: number;
    /**
     * 商品单价
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    unitPrice?: number;
    /**
     * 商品合计总价
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    totalPrice?: number;
    /**
     * 颜色
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    size?: string;
    /**
     * 商品链接  没有就用空字符串
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    url?: string;
    /**
     * 商品图片链接
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    imgUrl?: string;
    /**
     * 入库商品名
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    marketProNm?: string;
    /**
     * 商品选项名
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    marketOptionName?: string;
    /**
     * 商品选项ID
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    marketOptionId?: string;
    /**
     * 商品入库条码
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    marketBarcode?: string;
    /**
     * 商品到期日期 yyyy-MM-dd
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    marketExpiryDate?: string;
    /**
     * 原产地
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    origin?: string;
    /**
     * 原产地标作业方式
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    originJob?: string;
    /**
     * sku商品构成数量
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    constructCount?: number;
    /**
     * 通关类目id
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    ctmsItemId?: number;
    /**
     * 快递单号
     * @type {string}
     * @memberof AddOrUpdateGoodsVo
     */
    trackingNumber?: string;
    /**
     * 第三方购物平台id
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    businessPlatformId?: number;
    /**
     * 当前订单商品的平台条码快照列表
     * @type {Array<GoodsMarketBarcodeReqVo>}
     * @memberof AddOrUpdateGoodsVo
     */
    marketBarcodes?: Array<GoodsMarketBarcodeReqVo>;
    /**
     * 商品是否可以原包装出库  0 不可以，1 可以
     * @type {number}
     * @memberof AddOrUpdateGoodsVo
     */
    originPackageOutbound?: number;
    /**
     * 子快递单号数组，只给excel批量下单用，客户端页面下单不要用
     * @type {Array<string>}
     * @memberof AddOrUpdateGoodsVo
     */
    childrenTrackingNumbers?: Array<string>;
}

/**
 * Check if a given object implements the AddOrUpdateGoodsVo interface.
 */
export function instanceOfAddOrUpdateGoodsVo(value: object): value is AddOrUpdateGoodsVo {
    return true;
}

export function AddOrUpdateGoodsVoFromJSON(json: any): AddOrUpdateGoodsVo {
    return AddOrUpdateGoodsVoFromJSONTyped(json, false);
}

export function AddOrUpdateGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrUpdateGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'code': json['code'] == null ? undefined : json['code'],
        'sourceType': json['sourceType'] == null ? undefined : json['sourceType'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'skuProductId': json['skuProductId'] == null ? undefined : json['skuProductId'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'purchasePlatformUrl': json['purchasePlatformUrl'] == null ? undefined : json['purchasePlatformUrl'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'coGoodsNameEn': json['coGoodsNameEn'] == null ? undefined : json['coGoodsNameEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
        'hsCodeType': json['hsCodeType'] == null ? undefined : json['hsCodeType'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'availableQuantity': json['availableQuantity'] == null ? undefined : json['availableQuantity'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'url': json['url'] == null ? undefined : json['url'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketExpiryDate': json['marketExpiryDate'] == null ? undefined : json['marketExpiryDate'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'originJob': json['originJob'] == null ? undefined : json['originJob'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
        'marketBarcodes': json['marketBarcodes'] == null ? undefined : ((json['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeReqVoFromJSON)),
        'originPackageOutbound': json['originPackageOutbound'] == null ? undefined : json['originPackageOutbound'],
        'childrenTrackingNumbers': json['childrenTrackingNumbers'] == null ? undefined : json['childrenTrackingNumbers'],
    };
}

export function AddOrUpdateGoodsVoToJSON(json: any): AddOrUpdateGoodsVo {
    return AddOrUpdateGoodsVoToJSONTyped(json, false);
}

export function AddOrUpdateGoodsVoToJSONTyped(value?: AddOrUpdateGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'code': value['code'],
        'sourceType': value['sourceType'],
        'skuId': value['skuId'],
        'combined': value['combined'],
        'skuProductId': value['skuProductId'],
        'sort': value['sort'],
        'purchasePlatformUrl': value['purchasePlatformUrl'],
        'brand': value['brand'],
        'coGoodsNameEn': value['coGoodsNameEn'],
        'coHsCode': value['coHsCode'],
        'hsCodeType': value['hsCodeType'],
        'nameEn': value['nameEn'],
        'initQuantity': value['initQuantity'],
        'availableQuantity': value['availableQuantity'],
        'unitPrice': value['unitPrice'],
        'totalPrice': value['totalPrice'],
        'color': value['color'],
        'size': value['size'],
        'url': value['url'],
        'imgUrl': value['imgUrl'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'marketBarcode': value['marketBarcode'],
        'marketExpiryDate': value['marketExpiryDate'],
        'origin': value['origin'],
        'originJob': value['originJob'],
        'constructCount': value['constructCount'],
        'ctmsItemId': value['ctmsItemId'],
        'trackingNumber': value['trackingNumber'],
        'businessPlatformId': value['businessPlatformId'],
        'marketBarcodes': value['marketBarcodes'] == null ? undefined : ((value['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeReqVoToJSON)),
        'originPackageOutbound': value['originPackageOutbound'],
        'childrenTrackingNumbers': value['childrenTrackingNumbers'],
    };
}

